import { render, staticRenderFns } from "./DerivedAddressSummary.vue?vue&type=template&id=1d993811&scoped=true&"
import script from "./DerivedAddressSummary.vue?vue&type=script&setup=true&lang=js&"
export * from "./DerivedAddressSummary.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d993811",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
